window._ = require('lodash');

require('./polyfills.js');

window.Popper = require('popper.js/dist/umd/popper');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.$ = window.jQuery = require('jquery/dist/jquery');
  window.bsCustomFileInput = require('bs-custom-file-input');
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });

  require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */
window.Vue = require('vue');

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let tokenNode = document.head.querySelector('meta[name="csrf-token"]');

if (tokenNode) {
  window.token = tokenNode.content;
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.token;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

window.dateFormat = document.head.querySelector('meta[name="date-format"]').content;
window.dateTimeFormat = document.head.querySelector('meta[name="date-time-format"]').content;

import * as Sentry from '@sentry/browser';

if (window.environment != 'local') {
  Sentry.init({
    dsn: window.sentry_vue_dsn,
    ignoreErrors: [
      '401',
      '403',
      '419',
      'Error: Network Error',
      'ERR_CONNECTION_REFUSED',
      'Failed to fetch',
      'Error: Request aborted',
    ],
    release: window.release,
    environment: window.environment,
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js